// Open review/calendar tabs must not hold a serverless database awake forever.
// Refresh immediately on focus/mutations, frequently only during active work.
export function queuePolling(runs: Array<{ stage: string; publishAt?: string | null }> = [], now = Date.now()): number {
  const active = runs.some(r => ['planning','topic','structure','images','rejecting','assembly','pinterest','draft','assets','publishing'].includes(r.stage)
    || (['publication','scheduled'].includes(r.stage) && r.publishAt && Math.abs(Date.parse(r.publishAt) - now) < 15 * 60_000));
  return active ? 30_000 : 15 * 60_000;
}
